import React from 'react'
import { IndexTable, SkeletonBodyText } from '@shopify/polaris'

import TableRow, { SkeletonRow } from './TableRow'
import { onboardingSectionImage } from '../../../assets'

export default function ExperienceTable({
  experiences,
  filters,
  anyFiltersApplied,
  sectionStatsArray,
  statsLoading,
  activeModal,
  selectedExperienceId,
  shopLoading,
}) {
  const resourceName = {
    singular: 'section',
    plural: 'sections',
  }

  // Render skeleton rows if loading
  let rowMarkup = shopLoading
    ? Array.from({ length: 5 }).map((_, index) => <SkeletonRow key={index} />)
    : experiences.map((experience, index) => (
        <TableRow
          anyFiltersApplied={anyFiltersApplied}
          experience={experience}
          index={index}
          filters={filters}
          key={index}
          sectionStatsArray={sectionStatsArray}
          statsLoading={statsLoading}
          activeModal={activeModal}
        />
      ))

  return (
    <IndexTable
      resourceName={resourceName}
      itemCount={experiences.length || 5} // Show 5 rows for skeleton
      selectable={false}
      headings={[]}
      fullWidth
      loading={shopLoading}
    >
      {rowMarkup}
    </IndexTable>
  )
}
